// extracted by mini-css-extract-plugin
module.exports = {"LightStyle":"Lamp_LightStyle__2OoZu","Value":"Lamp_Value__2Z_Oq","Unit":"Lamp_Unit__1NYcc","BgStyle":"Lamp_BgStyle__2zdGn","BgTextWrapper":"Lamp_BgTextWrapper__3SaSa"};